/** Map raw API / network errors to user-friendly copy. */

export function formatApiError(message: string): string {
  const m = (message || '').toLowerCase()
  if (!m.trim()) return 'Something went wrong. Please try again.'

  if (m.includes('failed to fetch') || m.includes('networkerror') || m.includes('load failed')) {
    return 'Unable to reach the server. Check your connection or try again shortly.'
  }
  if (
    m.includes('max_connections') ||
    m.includes('connection limit') ||
    m.includes('hourly connection') ||
    m.includes('too many connections')
  ) {
    return 'Listings are temporarily unavailable. Please try again in a few minutes.'
  }
  if (m.includes('database temporarily unavailable')) {
    return message
  }
  if (m.includes('database error') || m.includes('internal server error')) {
    return 'Something went wrong loading data. Please try again in a moment.'
  }
  if (/http error!\s*status:\s*5/.test(m)) {
    return 'The server is busy right now. Please try again shortly.'
  }
  return message
}

export function isRetryableApiError(message: string): boolean {
  const m = (message || '').toLowerCase()
  return (
    m.includes('temporarily') ||
    m.includes('try again') ||
    m.includes('failed to fetch') ||
    m.includes('database') ||
    m.includes('http error! status: 5') ||
    m.includes('server is busy')
  )
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
